import { formatDateToYMD } from '@shared/utils/formatDate';
export function addDaysExcludeWeekend(startDate, days, holidaySet = new Set()) {
  if (!startDate) return null;

  const result = new Date(startDate);

  let count = 1;

  while (count < days) {
    result.setDate(result.getDate() + 1);

    const day = result.getDay();
    const formatted = formatDateToYMD(result);

    const isWeekend = day === 0 || day === 6;
    const isHoliday = holidaySet.has(formatted);

    if (!isWeekend && !isHoliday) {
      count++;
    }
  }

  return new Date(result);
}
